module.exports = __webpack_public_path__ + "static/media/tr808_tom_08.e3ca9799.wav";